import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_ACTIVE_ALERT,
  GET_AZURE_ACTIVE_ALERT_SUCCESS,
  GET_AZURE_ACTIVE_ALERT_ERROR,
} from "./constant";

import { getAzureActiveAlertApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureActiveAlertList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureActiveAlertApi, params, provider);
    yield put({ type: GET_AZURE_ACTIVE_ALERT_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_ACTIVE_ALERT_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureActiveAlertSaga() {
  yield takeLatest(GET_AZURE_ACTIVE_ALERT, getAzureActiveAlertList);
}
